import { injectStyle } from "./loader";

const shareStylesSet = new Set();

export function initShareStyles (styleObj, options) {
    let sharePromiseList = [];
    for (const [key, value] of Object.entries(styleObj)) {
        if (!shareStylesSet.has(key)) {
            shareStylesSet.add(key)
            sharePromiseList.push(injectStyle(value, options));
        }
    }
    return Promise.all(sharePromiseList);
}